import { AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * KAN-155: an amber "this may not work on SMS" note, shown next to an opt-out
 * option that many SMS providers defeat by blocking the customer themselves
 * (texts in OPT_OUT_SMS_WARNINGS). Same look in settings, Chat Automation, the
 * inbox and Compose.
 */
export function OptOutSmsWarning({ text, className, testId }: { text: string; className?: string; testId?: string }) {
  return (
    <div
      role="note"
      data-testid={testId}
      className={cn(
        'flex items-start gap-1.5 rounded-md border border-amber-300/60 bg-amber-500/10 px-2.5 py-1.5 text-[11px] leading-snug text-amber-700 dark:text-amber-300',
        className,
      )}
    >
      <AlertTriangle className="mt-px h-3.5 w-3.5 shrink-0" />
      <span>{text}</span>
    </div>
  );
}
